export default __webpack_public_path__ + "static/media/popup banner.0270c9e9.jpg";